export enum GameNotificationBlockType {
    User = 'user',
    Game = 'game',
    Text = 'text',
    Bot = 'bot',
    SpecialSeat = 'specialSeat',
};

export type GameNotificationUserBlockData = {
    id: number;
    name: string;
    avatar?: string;
}

export type GameNotificationUserBlock = {
    type: GameNotificationBlockType.User;
    user: GameNotificationUserBlockData;
}

export type GameNotificationGameBlockMapData = {
    id: number;
    name: string;
}

export type GameNotificationGameBlockData = {
    id: number;
    name?: string;
    map: GameNotificationGameBlockMapData;
}

export type GameNotificationGameBlock = {
    type: GameNotificationBlockType.Game;
    game: GameNotificationGameBlockData;
}

export type GameNotificationTextBlock = {
    type: GameNotificationBlockType.Text;
    text: string;
}

export type GameNotificationBotBlockData = {
    id: number;
    name: string;
}

export type GameNotificationBotBlock = {
    type: GameNotificationBlockType.Bot;
    bot: GameNotificationBotBlockData;
}

export type GameNotificationSpecialSeatBlock = {
    type: GameNotificationBlockType.SpecialSeat;
    seatNumber: number;
}

export type GameNotificationBlock = GameNotificationUserBlock
    | GameNotificationGameBlock
    | GameNotificationTextBlock
    | GameNotificationBotBlock
    | GameNotificationSpecialSeatBlock;
